import React, { useState } from 'react';
import bitmapBackground from 'assets/images/bitmap-background.png';
import MainLayout from 'components/layout/MainLayout';
import usePage from '@monorepo/shared/src/hooks/use-page';
import BookContent from 'components/modules/ReadBook/components/BookContent';
import ToggleReadingType from 'components/modules/ReadBook/components/ToggleReadingType';
import useBookParams from '@monorepo/shared/src/hooks/use-book-params';
import { ButtonTypes } from 'types';
import { BaseHtmlRenderingProviders } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@legacy/HTMLRenderEngine';
import { ReadingType } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/types';
import { useLocation } from 'react-router-dom';

const ReadBook: React.FC = () => {
  const bookParams = useBookParams();
  const [{ noOfPages }] = usePage();
  const [readingType, setReadingType] = useState(ReadingType.ReadStory);
  const location = useLocation();

  return (
    <BaseHtmlRenderingProviders noOfPages={noOfPages} WordFeature={null}>
      <MainLayout
        backgroundImg={bitmapBackground}
        menuProps={{
          primaryLeftButton: { name: ButtonTypes.HOME_BUTTON },
          secondaryLeftButton: {
            name: ButtonTypes.BACK_BUTTON,
            redirectRoute: { path: location?.state?.from ?? '/home' },
            variant: 'contained',
            color: 'inherit',
          },
        }}
        footerProps={{
          children: <ToggleReadingType readingType={readingType} onChange={setReadingType} />,
          primaryRightButton: { name: ButtonTypes.ACCESSIBILITY_BUTTON },
        }}
        gutterBottom
      >
        <BookContent bookParams={bookParams} readingType={readingType} />
      </MainLayout>
    </BaseHtmlRenderingProviders>
  );
};

export default ReadBook;
